import {Fragment} from '@wordpress/element';
import TabContent from './TabContent';

const ThemeContent = () => {
    return (
        <Fragment>
            <div className="blockline-theme-content">
               <TabContent/>
            </div>
        </Fragment>
    );
};
export default ThemeContent;